import { render, staticRenderFns } from "./ManageCourseIndex.vue?vue&type=template&id=0a7ec987&scoped=true"
import script from "./ManageCourseIndex.vue?vue&type=script&lang=js"
export * from "./ManageCourseIndex.vue?vue&type=script&lang=js"
import style0 from "./ManageCourseIndex.vue?vue&type=style&index=0&id=0a7ec987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ec987",
  null
  
)

export default component.exports